import CityManagementPage from "./shared/CityManagementPage";
import { cityConfigs } from "./shared/cityConfig";

export default function Sheffield() {
  return <CityManagementPage config={cityConfigs.sheffield} />;
}